import { ButtonMotion } from "./button-motion";
import { LabelWithIcon } from "../label";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export function ViewAllLink({ onClick, label = "View all" }) {
  return (
    <ButtonMotion>
      <LabelWithIcon
        labelProps={{
          variant: "xsmall",
          sx: { color: "primary.main" },
        }}
        label={label}
        endIcon={
          <ChevronRightIcon
            sx={{
              color: "primary.main",
            }}
          />
        }
        iconProps={{ sx: { p: 0 } }}
        clickableLabel
        onClick={onClick}
      />
    </ButtonMotion>
  );
}
